import { post } from '@alltrails/core/utils/post';
import type { TrailId } from '@alltrails/types/TrailId';
import type Waypoint from '../types/Waypoint';
import type { WaypointChangesResponse } from '../types/WaypointsApi';

export type AddWaypointToTrailPayload = {
  description: string;
  description_source?: string;
  location: Waypoint['location'];
  name: string;
  name_source?: string;
};

export function addWaypointToTrail(trailId: TrailId, waypoint: AddWaypointToTrailPayload) {
  const waypointPayload = {
    description: waypoint.description_source ? waypoint.description_source : waypoint.description,
    latitude: waypoint.location.latitude,
    longitude: waypoint.location.longitude,
    name: waypoint.name_source ? waypoint.name_source : waypoint.name
  };
  return post<WaypointChangesResponse>(`/api/alltrails/trails/${trailId}/waypoints`, waypointPayload);
}

export type AddWaypointToMapPayload = {
  description: string;
  location: Waypoint['location'];
  name: string;
  showTitle: boolean;
};

export function addWaypointToMap(mapId: number, waypoint: AddWaypointToMapPayload) {
  const waypointPayload = {
    description: waypoint.description,
    latitude: waypoint.location.latitude,
    longitude: waypoint.location.longitude,
    name: waypoint.name,
    showTitle: waypoint.showTitle
  };
  return post<WaypointChangesResponse>(`/api/alltrails/maps/${mapId}/waypoints`, waypointPayload);
}
